import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, computed, signal } from '@angular/core';

import { StatusModel } from '@core/models/status.model';

@Component({
  selector: 'ux-status',
  templateUrl: './status.component.html',
  imports: [CommonModule],
  standalone: true,
  styleUrls: ['./status.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusComponent {
  private readonly status$ = signal<StatusModel | null>(null);

  protected readonly statusStyle = computed(() => {
    const status = this.status$();
    return status?.color ? { 'border-color': status.color } : {};
  });

  protected readonly statusName = computed(() => this.status$()?.name ?? '');

  @Input()
  set status(value: StatusModel | null) {
    this.status$.set(value);
  }

  get status(): StatusModel | null {
    return this.status$();
  }
}
